import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_array } from "@swc/helpers/_/_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Translation } from '@core/locales';
import { Box, Prompt, ScrollArea, Stack, Text, Title, factory } from '@coveord/plasma-mantine';
import { Children, isValidElement, useMemo } from 'react';
import { Locales } from '../../../../strings/Locales.js';
import { PromptList } from '../../PromptList.js';
import classes from './DeleteBulkResourcesPrompt.module.css';
import { DeleteBulkResourcesPromptCancelButton } from './DeleteBulkResourcesPromptCancelButton.js';
import { DeleteBulkResourcesPromptConfirmButton } from './DeleteBulkResourcesPromptConfirmButton.js';
export var DeleteBulkResourcesPrompt = factory(function(_0, _1) {
    var _ref = [
        _0,
        _1
    ], _ref1 = _to_array(_ref), _ref2 = _ref1[0], _rest = _ref1.slice(1), additionalDescription = _ref2.additionalDescription, children = _ref2.children, onClose = _ref2.onClose, opened = _ref2.opened, resourceNames = _ref2.resourceNames, resourceType = _ref2.resourceType, promptProps = _object_without_properties(_ref2, [
        "additionalDescription",
        "children",
        "onClose",
        "opened",
        "resourceNames",
        "resourceType"
    ]), _rest1 = _sliced_to_array(_rest, 1), ref = _rest1[0];
    var normalizedResourceNames = resourceNames.map(function(name) {
        return name.trim();
    });
    var promptButtons = useMemo(function() {
        return Children.toArray(children).filter(function(child) {
            return /*#__PURE__*/ isValidElement(child) && (child.type === DeleteBulkResourcesPromptCancelButton || child.type === DeleteBulkResourcesPromptConfirmButton);
        });
    }, [
        children
    ]);
    return /*#__PURE__*/ _jsxs(Prompt.Critical, _object_spread_props(_object_spread({
        title: Locales.format('DeleteBulkResourcesPrompt.title', {
            resourceType: resourceType
        }),
        opened: opened,
        onClose: onClose,
        ref: ref
    }, promptProps), {
        children: [
            /*#__PURE__*/ _jsxs(Stack, {
                gap: "sm",
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        children: /*#__PURE__*/ _jsx(Translation, {
                            t: Locales,
                            i18nKey: "DeleteBulkResourcesPrompt.description.default",
                            options: {
                                smart_count: normalizedResourceNames.length,
                                resourceType: resourceType
                            },
                            children: /*#__PURE__*/ _jsx(Text, {
                                inherit: true,
                                span: true,
                                fw: 500
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Stack, {
                        gap: "xs",
                        children: [
                            /*#__PURE__*/ _jsx(Title, {
                                order: 5,
                                children: Locales.format('DeleteBulkResourcesPrompt.description.list.title', {
                                    resourceType: resourceType,
                                    resourceCount: normalizedResourceNames.length
                                })
                            }),
                            /*#__PURE__*/ _jsx(ScrollArea.Autosize, {
                                mah: 240,
                                scrollbars: "y",
                                classNames: classes,
                                children: /*#__PURE__*/ _jsx(PromptList, {
                                    children: normalizedResourceNames.map(function(name, ix) {
                                        return /*#__PURE__*/ _jsx(PromptList.Item, {
                                            label: name
                                        }, "resource-".concat(ix));
                                    })
                                })
                            })
                        ]
                    }),
                    additionalDescription && /*#__PURE__*/ _jsx(Box, {
                        "data-testid": "delete-bulk-resources-prompt-additional-description",
                        children: additionalDescription
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Prompt.Footer, {
                children: promptButtons
            })
        ]
    }));
});
DeleteBulkResourcesPrompt.CancelButton = DeleteBulkResourcesPromptCancelButton;
DeleteBulkResourcesPrompt.ConfirmButton = DeleteBulkResourcesPromptConfirmButton;
DeleteBulkResourcesPrompt.displayName = 'DeleteBulkResourcesPrompt';

//# sourceMappingURL=DeleteBulkResourcesPrompt.js.map